import React, { Component } from 'react';

import { ModalMask } from '@components/common';
import { AutofillButton } from '@components/common/AutofillButton';
import FilterContainer from '@components/filter-panel';
import { FIXED_FILTERS, SAVE_FILTER_PANEL_KEY } from '@components/filter-panel/constants';
import FilterName from '@components/summary-panel/FilterDropdown/FilterName';
import { getFilterFromRules, getRulesFromFilter, uuidv4 } from '@utils';
import track, { CLICK_FILTERS } from '@utils/track';

import styles from './index.less';

class FilterDropdown extends Component<any> {
  private readonly modalId: string;

  constructor(props) {
    super(props);
    this.modalId = uuidv4();
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.clickModalBg);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.clickModalBg);
  }

  clickModalBg = (event) => {
    if (event.target.id === this.modalId) {
      const {
        changeFilterContainerVisibility, // eslint-disable-line
      } = this.props;
      changeFilterContainerVisibility(false);
    }
  };

  clickClearFilter = () => {
    const { applyFilter } = this.props;
    const filterData = {
      name: '',
      rule: [],
      is_content: false,
    };
    const tempRules = getRulesFromFilter(filterData.rule, true);
    filterData.name = getFilterFromRules(tempRules, true).name;
    applyFilter(filterData);
  };

  showWidget = () => {
    const {
      changeFilterContainerVisibility: changeFilterContainerVisibilityAction,
      appliedFilter,
      updateActiveTab: updateActiveTabAction,
      updateFilterConditions: updateFilterConditionsAction,
    } = this.props;
    /* eslint-enable */
    const fixFilterNames = FIXED_FILTERS.map((f) => f.name);
    if (
      !appliedFilter.fid &&
      !fixFilterNames.includes(appliedFilter.name) &&
      !appliedFilter.presetFid // skip for preset filter
    ) {
      updateActiveTabAction(SAVE_FILTER_PANEL_KEY);
      const { rule } = appliedFilter;
      // force user to enter name
      updateFilterConditionsAction({ name: '', rule });
    }
    track({ event: CLICK_FILTERS });
    changeFilterContainerVisibilityAction(true);
  };

  render() {
    const { visible } = this.props;

    return (
      <div className={styles.fddContainer} id="emp-filter-row">
        <div className={styles.fddBtn}>
          <span className={styles.titleContainer}>
            <FilterName onClick={this.showWidget} />
            <AutofillButton>{this.props.children}</AutofillButton>
          </span>
        </div>
        {visible ? (
          <>
            <ModalMask id={this.modalId} />
            <div className={styles.fddContent}>
              <FilterContainer />
            </div>
          </>
        ) : null}
      </div>
    );
  }
}

export default FilterDropdown;
